export default __webpack_public_path__ + "static/card_reader_w.25349be95167e546024d98cb52a531e4.svg";